<template>
  <div class="layout">
    <layout-sidebar></layout-sidebar>
    <div class="layout_right">
      <layout-top></layout-top>
      <layout-main>
        <slot></slot>
      </layout-main>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  width: 100%;
  height: 100%;
  // overflow: hidden;
  // overflow: auto;
  &_right {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/index.vue